<template lang="pug">
  validation-observer(ref="form")
    form(@submit.prevent="onSubmit" :class="b()")
      //- currency-select(
      //-   v-model="data.currencyId"
      //-   v-validate="'required'"
      //-   :error-messages="errors.first('moneda')"
      //-   :disabled="disabled"
      //-   name="moneda"
      //- )
      validation-provider(name="cuota simple" :rules="rules.simpleFee" v-slot="{ errors }")
        label Cuota simple. ¿Cuánto pagas mes a mes?
        v-text-field-money(
          v-model="data.simpleFee"
          :disabled="disabled"
          name="cuota simple"
        )
      validation-provider(name="cuota doble" :rules="rules.doubleFee" v-slot="{ errors }")
        label Cuota Doble (solo si aplica)
        v-text-field-money(
          v-model="data.doubleFee"
          :error-messages="errors"
          :disabled="disabled"
          name="cuota doble"
        )
      validation-provider(name="meses por pagar" rules="required|numeric|min_value:60|max_value:299" v-slot="{ errors }")
        label Meses por pagar
        v-text-field(
          v-model.number="data.months"
          :error-messages="errors"
          :disabled="disabled"
          name="meses por pagar"
          type="number"
        )
      validation-provider(name="seguro" rules="required" v-slot="{ errors }")
        label Seguro
        insurance-select(
          v-model="data.insuranceTypeId"
          name="seguro"
          :error-messages="errors"
          :disabled="disabled"
        )
</template>

<script>
  import CurrencySelect from '@/components/inputs/currency-select';
  import InsuranceSelect from '@/components/inputs/insurance-type-select';
  import formMixin from '@/mixins/form-mixin';
  import PENtoUSD from '@/utils/pen-to-usd';

  const DEFAULT_VALUES = {
    simpleFee: null,
    doubleFee: null,
    months: null,
    insuranceTypeId: 2,
    currencyId: 1,
  };

  export default {
    name: 'mortgage-form',

    mixins: [
      formMixin({
        parseSubmit(data) {
          const doubleFee = data.doubleFee;

          return {
            ...data,
            simpleFee: data.simpleFee,
            doubleFee: doubleFee > 0 ? doubleFee : null,
          };
        },
      }),
    ],

    data() {
      return {
        data: {
          ...DEFAULT_VALUES,
        },
      };
    },

    computed: {
      rules() {
        const currencyId = this.data.currencyId;
        const { simpleFee, doubleFee } = this.data;

        return {
          simpleFee: {
            required: true,
            min_value: currencyId === 1 ? 1000 : parseInt(PENtoUSD(1000)),
            max_value: currencyId === 1 ? 4e4 : parseInt(PENtoUSD(4e4)),
          },
          doubleFee: {
            min_value: (simpleFee && doubleFee > 0) ? simpleFee + 1 : 0,
            max_value: currencyId === 1 ? 8e4 : parseInt(PENtoUSD(8e4)),
          },
        };
      },
    },

    components: {
      CurrencySelect,
      InsuranceSelect,
    },
  };
</script>

<style lang="sass" scoped>
  .customer-form
    &__error
      color: red
      font-size: 0.9rem

    .label
      font-size: 0.85rem
      margin: 0
</style>